<div class="envio-simple-page" *ngIf="resultado as resumen">
  <h1 class="envio-simple-page__title">Envío simple</h1>

  <app-envio-simple-stepper
    [elementos]="envioSimpleFlowService.PASOS"
    [stepActive]="envioSimpleFlowService.pasoActivo">
  </app-envio-simple-stepper>

  <div class="envio-simple-page__scroll">
    <section
      class="envio-confirmacion-banner"
      [class.envio-confirmacion-banner--ok]="esExito"
      [class.envio-confirmacion-banner--error]="!esExito">
      <svg class="envio-confirmacion-banner__icon" aria-hidden="true">
        <use [attr.xlink:href]="esExito ? '#hs-tick-circle' : '#hs-alert'"></use>
      </svg>
      <p class="envio-confirmacion-banner__texto">{{ resumen.mensajePrincipal }}</p>
    </section>

    <section class="envio-confirmacion-contenido">
      <app-envio-simple-ficheros-subidos
        class="envio-confirmacion-ficheros"
        titulo="Documentos enviados"
        orientacion="horizontal"
        [soloLectura]="true">
      </app-envio-simple-ficheros-subidos>

      <div class="envio-confirmacion-contenido__firmantes">
        <app-envio-simple-confirmacion-firmantes-grid
          [firmantes]="resumen.firmantes"
          [mostrarEmail]="mostrarEmail"
          [mostrarTelefono]="mostrarTelefono">
        </app-envio-simple-confirmacion-firmantes-grid>
      </div>
    </section>
  </div>
</div>

<div class="envio-simple-footer" *ngIf="resultado">
  <div class="envio-simple-footer__left"></div>
  <div class="envio-simple-footer__right">
    <app-boton-accion-secundaria
      (click)="irAlPanel()"
      [id]="'ir-panel-confirmacion'"
      [icono]="'hs-arrow-back'"
      [titulo]="'Ir al panel de control'">
    </app-boton-accion-secundaria>
  </div>
</div>
